import { FLIGHT_STATUS_VALUES } from "constants/variables";

export const showArrivalText = (status: string) => {
  if (status === FLIGHT_STATUS_VALUES.DELAYED || status === FLIGHT_STATUS_VALUES.EARLY || status === FLIGHT_STATUS_VALUES.ONTIME) {
    return "Scheduled Arrival";
  }
  if (status === FLIGHT_STATUS_VALUES.NOT_DEPARTED) {
    return "Estimated Arrival";
  }
  if (status === FLIGHT_STATUS_VALUES.YET_TO_DEPART) {
    return "Scheduled Arrival";
  }
  if (status === FLIGHT_STATUS_VALUES.ARRIVED) {
    return "Arrived";
  }
  if (status === FLIGHT_STATUS_VALUES.ARRIVED_EARLY) {
    return "Arrived";
  }
  if (status === FLIGHT_STATUS_VALUES.ARRIVED_LATE) {
    return "Arrived";
  }
  return "Expected Arrival";
};
